window.app.factory("getEnterprisePlatformConfig", [
  "$rootScope",
  "apiCall",
  function($rootScope, apiCall) {
    var differingBundleNames = {
      myprofile: "profile",
      mybenefits: "benefits",
      hrpolicies: "content"
    };

    return function fetchConfig() {
      const endpoint = `enterprisePlatformConfig/${
        $rootScope.publicMode ? "public/" : ""
      }$`;
      return apiCall({ endpoint }).then(config => {
        config.appName = config.appName || window.orgConfig.appName || "Cue";
        config.id = window.interceptor.enterprise.code;

        if (config.appDetails) {
          config.appDetails.forEach(function(app) {
            app.bundleName = differingBundleNames[app.appId] || app.appId;
          });

          config.appDetails.sort((a, b) => a.order - b.order);
        }

        $rootScope.enterpriseConfig = config;

        // Add custom CSS
        apiCall({ endpoint: "themes/$/custom.css" }).then(css => {
          const { $ } = window;
          const style = $("<style id='custom-css'></style>")[0];
          style.innerHTML = css;
          window.$("head").append(style);
        });

        const themeEndpoint = $rootScope.publicMode
          ? "/themes/publictheme/$"
          : "/themes/$";

        // Fetch theme & layout settings
        return apiCall({ endpoint: themeEndpoint }).then(theme => {
          $rootScope.theme = theme;
          $rootScope.appLayout = theme.layoutSettings || {
            showSideMenu: true,
            showSearchOnHeader: true,
            hideSideMenuOnDashboard: false,
            hideHeaderSearchOnDashboard: false,
            showBackgroundImageOnDashboard: true,
            showNewsOnDashboard: false,
            dashboardTemplate: 1,
            appTileStyle: 1
          };

          window.$("head").append(`
            <style>
              .dashboard-logo {
                background-image: url('${theme.dashboardLogo}');
            }
            </style>
          `);
          return config;
        });
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/helpers/enterprisePlatformConfig.js